import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { QuestionsPage } from '@/pages/Questions';
import { QuestionWizard } from '@/pages/QuestionWizard';
import { Approvals } from '@/pages/Approvals';
import { QuestionBank } from '@/pages/QuestionBank';
import { LearningIndicators } from '@/pages/LearningIndicators';
import { Reports } from '@/pages/Reports';
import { Users } from '@/pages/Users';
import { SubjectPermissions } from '@/pages/SubjectPermissions';
import { Metadata } from '@/pages/Metadata';
import { BackupPage } from '@/pages/Backup';
import { ActivityLog } from '@/pages/ActivityLog';
import { useAuth } from '@/store/auth';
import type { Role } from '@/types';

function Protected({ children, roles }: { children: React.ReactNode; roles?: Role[] }) {
  const user = useAuth((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="/questions" element={<Protected roles={['teacher', 'academic_admin', 'admin']}><QuestionsPage /></Protected>} />
        <Route path="/questions/new" element={<Protected roles={['teacher', 'academic_admin', 'admin']}><QuestionWizard /></Protected>} />
        <Route path="/questions/edit/:id" element={<Protected roles={['teacher', 'academic_admin', 'admin']}><QuestionWizard /></Protected>} />
        <Route path="/approvals" element={<Protected roles={['academic_admin', 'admin']}><Approvals /></Protected>} />
        <Route path="/question-bank" element={<QuestionBank />} />
        <Route path="/learning-indicators" element={<Protected roles={['teacher', 'academic_admin', 'admin']}><LearningIndicators /></Protected>} />
        <Route path="/reports" element={<Protected roles={['admin', 'academic_admin']}><Reports /></Protected>} />
        <Route path="/users" element={<Protected roles={['admin']}><Users /></Protected>} />
        <Route path="/subject-permissions" element={<Protected roles={['admin']}><SubjectPermissions /></Protected>} />
        <Route path="/metadata" element={<Protected roles={['admin']}><Metadata /></Protected>} />
        <Route path="/backup" element={<Protected roles={['admin']}><BackupPage /></Protected>} />
        <Route path="/activity" element={<ActivityLog />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
